import {ProofType} from '../enumerations';
import {devUrlService, prodUrlService} from './urls/live'; // Options:  live |  mocs

const isDevelop = __DEV__;
let apiUrl = isDevelop ? devUrlService : prodUrlService;

const remote = {
  getLoginUri: () => `${apiUrl}/login`,
  getEntitiesUri: () => `${apiUrl}/entities`,
  getTycUri: () => `${apiUrl}/terms-conditions`,
  getBalanceListUri: () => `${apiUrl}/balance`,
  getSubClientBalanceListUri: (clientId: string) =>
    `${apiUrl}/salesman/balance-list/${clientId}`,
  getDocumentListUri: () => `${apiUrl}/documents-list`,
  getHistoryUri: () => `${apiUrl}/records-pays`,
  getSubClientHistoryUri: (clientId: string) => {
    return `${apiUrl}/salesman/payments/${clientId}`;
  },
  getSignUpUri: () => `${apiUrl}/register`,
  getNotificationsListUri: (readed?: boolean) =>
    `${apiUrl}/notifications${readed ? '/read' : ''}`,
  getSendProofUri: (type?: ProofType, isSalesman = false) => {
    const pathRol = isSalesman ? '/salesman' : '';
    let path = '/payment';
    if (type === ProofType.incomeTax) {
      path = '/income';
    } else if (type === ProofType.vatTax) {
      path = '/vattax';
    }
    return `${apiUrl}${pathRol}${path}`;
  },
  getClientsUri: () => {
    return `${apiUrl}/salesman/clients`;
  },
  getRecoverPasswordUri: () => `${apiUrl}/passwordreset`,
  getChangePasswordUri: () => `${apiUrl}/changepasswordmanual`,
  getSendBalanceByEmailUri: (isSalesman: boolean) => {
    if (isSalesman) {
      return `${apiUrl}/salesman/send-balance`;
    }
    return `${apiUrl}/sendbalance`;
  },
  getBalanceSheetUri: () => {
    return `${apiUrl}/balance-general`;
  },
  getSalesmanBalanceSheetUri: () => {
    return `${apiUrl}/salesman/balance-sheet`;
  },
  getSubclientBalanceSheetUri: (clientId?: string) => {
    return `${apiUrl}/salesman/balance-general/${clientId}`;
  },
  getRemoveAccountUri: () => `${apiUrl}/delete-user`,
  getSemaphoreUri: () => `${apiUrl}/semaphore`,
  getSalesmanSemaphoreUri: () => `${apiUrl}/salesman/semaphore`,
  getDebtorsListUri: (key: string) => `${apiUrl}/list-debtors/key/${key}`,
  getSalesmanDebtorsListUri: (key: string) =>
    `${apiUrl}/salesman/debtors/key/${key}`,
  getClientDebtorsListUri: (key: string) =>
    `${apiUrl}/client/debtors/key/${key}`,
  getSalesmanClientListUri: () => `${apiUrl}/salesman/clients`,
  getReceivablesByDebtorUri: (key: string, rif: string) =>
    `${apiUrl}/debtor/key/${key}/${rif}`,
  getSalesmanReceivablesByDebtorUri: (key: string, rif: string) =>
    `${apiUrl}/salesman/debtor/key/${key}/${rif}`,
  getAppInfoUri: () => `${apiUrl}/app-info`,
  getRegisterDeviceUri: () => `${apiUrl}/register-device`,
  getSalesmanProductsListUri: () => `${apiUrl}/salesman/products`,
  getSalesmanResourcesUri: () => `${apiUrl}/salesman/resources`,
  getSalesmanScheduleUri: () => `${apiUrl}/salesman/schedule`,
  getClientResourcesUri: () => `${apiUrl}/client/resources`,
  getClientBalanceSheetUri: () => {
    return `${apiUrl}/client/balance-sheet`;
  },
  getClientSemaphoreUri: () => `${apiUrl}/client/semaphore`,
  getClientProductsListUri: () => `${apiUrl}/client/products`,
  getSalesmanOrdersUri: () => `${apiUrl}/salesman/orders`,
  getSalesmanOrdersListUri: () => `${apiUrl}/salesman/orders/list`,
  getSalesmanCandidateOrderListUri: () =>
    `${apiUrl}/salesman/orders/list/candidates`,
  getSalesmanInvoiceCandidateListUri: (clientId: string) =>
    `${apiUrl}/salesman/invoices/candidates/${clientId}`,
  getSalesmanInvoicesUri: () => `${apiUrl}/salesman/invoices`,
  getCandidateOrderListUri: (clientId: string) =>
    `${apiUrl}/salesman/orders/candidates/list/${clientId}`,
  getCandidateOrderUri: (orderId: string) =>
    `${apiUrl}/salesman/orders/candidates/${orderId}`,
  getInvoiceFeeCandidates: () => `${apiUrl}/sub-client/fees/unpaided`,
  getC2PPaymentBase: () => `${apiUrl}/sub-client/payment/c2p/context`,
  getC2PPaymentPost: () => `${apiUrl}/sub-client/payment/c2p`,
  getCreditCardPaymentPost: () => `${apiUrl}/sub-client/payment/credit-card`,
  getC2PPaymentConfirmationPost: () =>
    `${apiUrl}/sub-client/payment/c2p/confirmation`,
  getFeeSendProofUri: () => {
    return `${apiUrl}/sub-client/fees/payment/proof`;
  },
};

export default remote;
